export function addAsterickOnError (error: boolean, str: string) {
  if(error){
    return `(*) ${str}`;
  } else {
    return str;
  }
};